<app-header class='no-print' role=”complementary”></app-header>

<div class="container">
  <app-breadcrumbs class='no-print' role=”complementary”></app-breadcrumbs>
</div>

<div class="container">
  <div class="row" *ngIf="loadIssue">
    <div class="col-md-12">
      <p class="alert-danger" [innerHTML]="'COMMON.LOAD_ISSUE' | translate"></p>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="rgb(0, 255, 31)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: #fff">{{ 'COMMON.LOADING' | translate}}</p>
</ngx-spinner>

<router-outlet role="main" (activate)="onActivate($event)"></router-outlet>

<app-footer class='no-print' role=”complementary”></app-footer>